import React, { Component } from "react";
import EditMatchDialog from "../../components/schedule/EditMatchDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import LockIcon from "@material-ui/icons/Lock";

class EditMatchContainer extends Component {
  state = {
    open: false,
    referee: "",
    referee2: "",
    referee3: "",
    referee4: "",
    referee5: "",
    switched: false,
    duration: "",
    removeFromScheduleConfirm: false,
  };

  toggleDialog = () => {
    this.props.toggleDialog();
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      if (this.state.open) {
        this.props.onMouseLeave();
      }
      this.setState({ open: !this.state.open, switched: false });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const match = nextProps.match;
    if (match) {
      if (
        this.props.match.referee !== match.referee ||
        this.props.match.referee2 !== match.referee2 ||
        this.props.match.referee3 !== match.referee3 ||
        this.props.match.referee4 !== match.referee4 ||
        this.props.match.referee5 !== match.referee5
      ) {
        this.updateState(match);
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.match) {
      this.updateState(this.props.match);
    }
  };

  updateState = (match) => {
    this.setState({
      referee: match.referee || "",
      referee2: match.referee2 || "",
      referee3: match.referee3 || "",
      referee4: match.referee4 || "",
      referee5: match.referee5 || "",
      duration:
        match.duration !== undefined && match.duration !== null
          ? match.duration
          : "",
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const switched = this.state.switched;
    this.toggleDialog();
    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let toUpdate = {
      referee: this.state.referee,
      referee2: this.state.referee2,
      referee3: this.state.referee3,
      referee4: this.state.referee4,
      referee5: this.state.referee5,
      duration: null,
    };

    if (this.state.duration !== "" && this.state.duration > 0) {
      toUpdate["duration"] = this.state.duration;
    }

    if (switched) {
      toUpdate["team1"] = this.props.match.team2;
      toUpdate["team2"] = this.props.match.team1;
    }

    batch.update(
      tournamentRef.collection("matches").doc(this.props.match.id),
      toUpdate
    );

    batch.set(db.collection("cacheUpdates").doc(), {
      tournamentId: this.props.tournament[".key"],
      fieldId: this.props.match.field,
      dayId: this.props.match.day,
      status: "pending",
      timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
    });
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
    batch.commit();
  };

  handleSwitch = (e) => {
    e.preventDefault();
    this.setState({ switched: !this.state.switched });
  };

  removeMatchFromSchedule = (e) => {
    e.preventDefault();
    if (!this.state.removeFromScheduleConfirm) {
      this.setState({ removeFromScheduleConfirm: true });
    } else {
      const db = window.firebase.firestore();
      let batch = db.batch();

      const tournamentRef = window.firebase
        .firestore()
        .collection("tournaments")
        .doc(this.props.tournament[".key"]);

      let toUpdate = {
        field: null,
        day: "0",
        referee: "",
        referee2: "",
        referee3: "",
        referee4: "",
        referee5: "",
        st: "",
        et: "",
        duration: null,
      };

      batch.update(
        tournamentRef.collection("matches").doc(this.props.match.id),
        toUpdate
      );

      batch.set(db.collection("cacheUpdates").doc(), {
        tournamentId: this.props.tournament[".key"],
        fieldId: this.props.match.field,
        dayId: this.props.match.day,
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
      if (this.props.tournament.ia) {
        batch.set(db.collection("cacheUpdatesApp").doc(), {
          tournamentId: this.props.tournament[".key"],
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
      }
      batch.commit();
      this.toggleDialog();
    }
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={
            this.props.tournament.scheduleLocked || false
              ? () => {}
              : this.toggleDialog
          }
          style={{ height: 20, width: 20, marginTop: 11 }}
        >
          {this.props.tournament.scheduleLocked || false ? (
            <LockIcon
              style={{ height: 20, width: 20, position: "absolute", top: 2 }}
            />
          ) : (
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 2 }}
            />
          )}
        </IconButton>

        {this.state.open && (
          <EditMatchDialog
            selectedReferee={this.state.referee}
            selectedReferee2={this.state.referee2}
            selectedReferee3={this.state.referee3}
            selectedReferee4={this.state.referee4}
            selectedReferee5={this.state.referee5}
            open={this.state.open}
            match={this.props.match}
            toggleDialog={this.toggleDialog}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
            referees={this.props.referees}
            handleSwitch={this.handleSwitch}
            team1={this.props.team1}
            team2={this.props.team2}
            switched={this.state.switched}
            duration={this.state.duration}
            tournament={this.props.tournament}
            removeMatchFromSchedule={this.removeMatchFromSchedule}
            removeFromScheduleConfirm={this.state.removeFromScheduleConfirm}
          />
        )}
      </div>
    );
  }
}

export default EditMatchContainer;
